const decodePolyline = (encoded: string): [number, number][] => {
  let index = 0;
  const coordinates: [number, number][] = [];
  let lat = 0;
  let lng = 0;

  while (index < encoded.length) {
    let shift = 0;
    let result = 0;
    let byte;

    do {
      byte = encoded.charCodeAt(index) - 63;
      index += 1;
      result += (byte % 32) * 2 ** shift;
      shift += 5;
    } while (byte >= 32);

    const deltaLat =
      result % 2 === 1 ? -Math.floor(result / 2) : Math.floor(result / 2);
    lat += deltaLat;

    shift = 0;
    result = 0;

    do {
      byte = encoded.charCodeAt(index) - 63;
      index += 1;
      result += (byte % 32) * 2 ** shift;
      shift += 5;
    } while (byte >= 32);

    const deltaLng =
      result % 2 === 1 ? -Math.floor(result / 2) : Math.floor(result / 2);
    lng += deltaLng;

    coordinates.push([lat / 1e5, lng / 1e5]);
  }

  return coordinates;
};

export default decodePolyline;
